// extracted by mini-css-extract-plugin
export var modalFooter = "_mq-0";